import {NotificationComponent} from './notification.component';
import {NgModule} from '@angular/core';
import {SecureURLPipeModule} from '../util/secureURL.pipe.module';
import {CommonModule} from '@angular/common';

@NgModule({
    imports: [
        SecureURLPipeModule,
        CommonModule
    ],
    declarations: [NotificationComponent],
    providers: [],
    exports: [NotificationComponent],
})

export class NotificationModule {
}
